<template>
    <div v-if="list.length" class="sustainability">
        <van-tabs v-model="active" animated="animated" type="card" title-inactive-color="#7EB61C">
            <van-tab
                :title="item.name"
                :name="item.detail.routeName"
                v-for="item in list"
                :key="item.id"
            >
            </van-tab>
        </van-tabs>
        <router-view></router-view>
    </div>
</template>

<script>
const { CMS } = window.env
import { getDataHierarchies } from '@custouch/proxy-use'
export default {
    data() {
        return {
            list: []
        }
    },
    computed: {
        active: {
            set(name) {
                this.$router.replace({ name })
            },
            get() {
                return this.$route.name
            }
        }
    },
    async created() {
        this.list = await getDataHierarchies(CMS.module.sustainability)
    }
}
</script>

<style lang="less">
@import '~@/assets/style/mixin.less';
.sustainability {
    padding: @padding-lg @padding-md 0;
    .van-tabs__nav--card{
        margin: 0;
        border-radius: @border-radius-sm + @border-radius-md @border-radius-sm + @border-radius-md 0 0;
        height: @stepper-input-height;
        border-color: @sustainabilityColor;
        .van-tab{
            border-color: @sustainabilityColor;
            &.van-tab--active{
                background: @sustainabilityColor;
                font-weight: 400;
            }
            &:first-of-type{
               border-top-left-radius: @border-radius-sm + @border-radius-md; 
            }
            &:last-of-type{
                border-top-right-radius: @border-radius-sm + @border-radius-md;
            }
        }
    }
    .desc-box {
        padding: @padding-base*5 @padding-sm;
        background: #f2f7ea;
        border-radius: @border-radius-sm + @border-radius-md;
        .desc-title {
            margin-bottom: @padding-md;
        }
    }
}
</style>
